import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'mage-react-router';

import LoginModal from '@/components/login/LoginModal';

import { ACCOUNT_TYPES, isDingtalk } from '@/constants/common';

class HeadhunterLogin extends React.Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit({ email, password }) {
    this.props.login({ email: email, pwd: password });
  }

  render() {
    const { me, needCaptcha, setNECaptchaValidate, showError } = this.props;
    return (
      <div className="headhunter-login-page">
        <div className="login-header">
          {!isDingtalk && (
            <>
              <span className="icon icon-logo" />
              <span className="icon icon-moka" />
            </>
          )}
        </div>
        <div className="login-div">
          <LoginModal
            accountType={ACCOUNT_TYPES.HEADHUNTER}
            message={me.message}
            wrongPasswordTimes={me.wrongPasswordTimes}
            forbiddenTime={me.forbiddenTime}
            needCaptcha={needCaptcha}
            showError={showError}
            onSubmit={this.onSubmit}
            setNECaptchaValidate={setNECaptchaValidate}
          />
        </div>
      </div>
    );
  }
}

HeadhunterLogin.propTypes = {
  login: PropTypes.func.isRequired,
  setNECaptchaValidate: PropTypes.func,
  showError: PropTypes.bool,
};

export default withRouter(HeadhunterLogin);
